import React from "react"
import DateFilterOptions from "@/pages/Admin/ClientCatalog/ClientManageFilters/ContactsFilters/components/DateFilterOptions"
import { ContactsFiltersConditions, DateFilterState } from "@/protocols/ClientCatalogFilterProtocol"

type ContactUpdateDateFilterConditionProps = {
	condition: ContactsFiltersConditions<"contact_update_date">
	onChange: (condition: ContactsFiltersConditions<"contact_update_date">) => void
}

const ContactUpdateDateFilterCondition: React.FC<ContactUpdateDateFilterConditionProps> = ({ condition, onChange }) => {
	const handleChange = (options: DateFilterState) => {
		onChange({
			type: "contact_update_date",
			operator: options.operator,
			filterData: {
				dateFrom: options.dateFrom,
				dateTo: options.dateTo
			}
		})
	}

	return (
		<DateFilterOptions
			operator={condition.operator}
			onChange={handleChange}
			dateFrom={condition.filterData?.dateFrom}
			dateTo={condition.filterData?.dateTo}
		/>
	)
}

export default ContactUpdateDateFilterCondition
